import { getPublicSocket } from "../socket/index.js";
import { ROUTE_RENDERED_EVENT } from "../router/index.js";

/** Signale au serveur la page courante de l'onglet (présence live visible
 *  dans /admin/presence). Seuls le chemin — sans query string ni fragment,
 *  qui peuvent contenir des jetons — le titre et la visibilité de l'onglet
 *  sont envoyés ; l'identité est déduite côté serveur de la session. */
export function startPresenceReporter(): void {
  const socket = getPublicSocket();
  let timer: number | undefined;

  const send = (): void => {
    if (!socket.connected) return;
    socket.emit("public:presence", {
      path: window.location.pathname || "/",
      title: document.title.slice(0, 300),
      visible: document.visibilityState === "visible",
    });
  };
  // Petit délai : laisse la page poser son `document.title` et absorbe les
  // redirections en chaîne (guards) avant d'envoyer.
  const schedule = (): void => {
    if (timer !== undefined) window.clearTimeout(timer);
    timer = window.setTimeout(() => { timer = undefined; send(); }, 200);
  };

  socket.on("connect", schedule);
  window.addEventListener(ROUTE_RENDERED_EVENT, schedule);
  window.addEventListener("popstate", schedule);
  document.addEventListener("visibilitychange", schedule);
  if (socket.connected) schedule();
}
